// Opens the Save to list dialog (apps/on_boarding, OnBoardingAddToListPage.vue) for a
// recording: the same dialog, rules and look as a hike's, from the recording page's Add to
// list button and each My Recordings card's bookmark. Signed out, the dialog's flow asks the
// viewer to sign in first, exactly as it does for a hike.

import { OnBoardingGoal } from '../models/OnBoardingGoal';

/** save_to_list_opened's `source` for a recording card; the page's comes from its path. */
export const RECORDING_CARD_SOURCE = 'recording_card';

export function recordingSaveToListContext(
  recordingId: string | number,
  recordingName: string | null | undefined,
  source?: string,
): { recordingId: string; recordingName: string; saveToListSource?: string } {
  return {
    recordingId: String(recordingId),
    recordingName: recordingName || '',
    ...(source ? { saveToListSource: source } : {}),
  };
}

/** Returns whether the dialog could be opened (the onboarding app is mounted on the page). */
export function openRecordingSaveToList(
  recordingId: string | number | null | undefined,
  recordingName?: string | null,
  source?: string,
): boolean {
  const onboarding = (window as any).onBoardingVue;
  if (recordingId == null || recordingId === '' || typeof onboarding?.launchFor !== 'function') return false;
  onboarding.setAddToListContext?.(recordingSaveToListContext(recordingId, recordingName, source));
  onboarding.launchFor(OnBoardingGoal.AddTrailToList);
  return true;
}
